import { render, staticRenderFns } from "./dbFuncEdit.vue?vue&type=template&id=ac4221f2&scoped=true&"
import script from "./dbFuncEdit.vue?vue&type=script&lang=js&"
export * from "./dbFuncEdit.vue?vue&type=script&lang=js&"
import style0 from "./dbFuncEdit.vue?vue&type=style&index=0&id=ac4221f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4221f2",
  null
  
)

export default component.exports